import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container mt-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("h1", null, " Update Personal Information")
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "row mb-4" }, [
  /*#__PURE__*/_createElementVNode("span", null, " Enter the information you wish to update in the applicable field. Any changes and/or accompanying documentation will be reviewed by our administrative team prior to being made permanent. Note that all fields marked with an asterisk are required fields. ")
], -1)
const _hoisted_4 = { class: "row mb-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "STEP 1 - Participant General Information")
], -1)
const _hoisted_6 = { class: "col-md-12 mb-4" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-6 text-right" }
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UpdateInfoStep2 = _resolveComponent("UpdateInfoStep2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        ($setup.currentStep === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_UpdateInfoStep2, { documentTypes: $setup.documentTypes }, null, 8, ["documentTypes"])
            ]))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          ($setup.currentStep == 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.goToPreviousStep && $setup.goToPreviousStep(...args)))
              }, " Back "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_11, [
          ($setup.currentStep == 2)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "btn btn-secondary",
                disabled: $setup.loading,
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
              }, _toDisplayString($setup.loading ? 'Uploading...' : 'Submit'), 9, _hoisted_12))
            : (_openBlock(), _createElementBlock("button", {
                key: 1,
                type: "button",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.goToNextStep && $setup.goToNextStep(...args))),
                class: "btn btn-secondary"
              }, "Step 2"))
        ])
      ])
    ])
  ]))
}